/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

// Register Roboto Font
Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

const UtilsInstance = new Utils();

export class MonitoringReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      monitoringFirstOverviewPage: -1,
      monitoringFirstLiveListPage: -1,
      monitoringFirstInventoryPage: -1,
      monitoringFirstTopologyPage: -1,
      monitoringFirstInTrafficErrorsPage: -1,
      monitoringFirstOutTrafficErrorsPage: -1,
      monitoringFirstLogPage: -1,
      // Summary numbering control
      isFirstOverviewPage: true,
      isFirstLiveListPage: true,
      isFirstInventoryPage: true,
      isFirstTopologyPage: true,
      isFirstInTrafficErrorsPage: true,
      isFirstOutTrafficErrorsPage: true,
      isFirstLogPage: true,
      // The report itself
      doc: ""
    };
  }

  // ------------------------ Utilities -------------------------
  getDateNow = () => {
    return (
      this.state.generatingDate.getDate()
      + "/"
      + (this.state.generatingDate.getMonth() + 1)
      + "/"
      + this.state.generatingDate.getFullYear()
    );
  }

  getRectImage = (isFilled) => {
    if (isFilled) {
      return <Image src={`${process.env.PUBLIC_URL}/images/filled-rect.png`} style={generalInfoStyles.rectangle} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={generalInfoStyles.rectangle} />;
    }
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  whenWasTurnedOnAsDate = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return dateWhenWasTurnedOn;
    }
  }

  getMonitorInitTime = () => {
    let drawDate = this.whenWasTurnedOnAsDate(this.props.uptime);
    let year = drawDate.getFullYear();
    let month = drawDate.getMonth() + 1;
    let day = drawDate.getDate();
    let hour = drawDate.getHours();
    let minutes = drawDate.getMinutes();
    let seconds = drawDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds;
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  /*
  The measurement time that is retrieved from the database comes as a string.
  We had a problem that the time that was being retrieved was not correct. 
  The workarround we found for this was to remove the last two characters of 
  the string and it miraculously it was in the format we nedded 
*/
  formatUptimeStringToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined && uptimeInSeconds !== "None" && uptimeInSeconds !== "") {
      let uptimeSubstring = uptimeInSeconds.substring(0, uptimeInSeconds.length - 2);
      let uptimeSubstringNumber = parseInt(uptimeSubstring);
      const uptimeInMillis = uptimeSubstringNumber * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
    else if (uptimeInSeconds === "None" || uptimeInSeconds === "") {
      return Strings.NO_ANSWER;
    }
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + "h");
    if (nd > 0) out.push(nd + "m");
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  formatToRelativeTime2 = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince2(new Date(dateWhenWasTurnedOn));
    }
  }

  getDateTimeSince2 = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth2(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) out.push(md + Strings.MONTH + (md === 1 ? "" : "s"));
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    if (sd > 0) out.push(sd + Strings.SECOND + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  getDaysInMonth2 = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={headerStyles.container}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={headerStyles.logo} />
          <Text style={headerStyles.text}>{Strings.HEADER_TEXT}</Text>
        </View>
        <View style={headerStyles.line}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = (reportPart) => {
    return (
      <View style={footerStyles.container} fixed>
        <View style={footerStyles.line}></View>
        <View>
          <Text style={footerStyles.text} render={({ pageNumber, totalPages }) => {
            this.setFirstPageNumbers(reportPart, pageNumber);
            return (`${this.getDateNow()}, ${Strings.PAGE} ${pageNumber} / ${totalPages}`);
          }} fixed />
        </View>
      </View>
    );
  }

  setFirstPageNumbers = (reportPart, pageNumber) => {
    if (reportPart === "overview" && this.state.isFirstOverviewPage) {
      this.setState({
        monitoringFirstOverviewPage: pageNumber + 1,
        isFirstOverviewPage: false
      });
    }
    else if (reportPart === "livelist" && this.state.isFirstLiveListPage) {
      this.setState({
        monitoringFirstLiveListPage: pageNumber + 1,
        isFirstLiveListPage: false
      });
    }
    else if (reportPart === "inventory" && this.state.isFirstInventoryPage) {
      this.setState({
        monitoringFirstInventoryPage: pageNumber + 1,
        isFirstInventoryPage: false
      });
    }
    else if (reportPart === "topology" && this.state.isFirstTopologyPage) {
      this.setState({
        monitoringFirstTopologyPage: pageNumber + 1,
        isFirstTopologyPage: false
      });
    }
    else if (reportPart === "inerror" && this.state.isFirstInTrafficErrorsPage) {
      this.setState({
        monitoringFirstInTrafficErrorsPage: pageNumber + 1,
        isFirstInTrafficErrorsPage: false
      });
    }
    else if (reportPart === "outerror" && this.state.isFirstOutTrafficErrorsPage) {
      this.setState({
        monitoringFirstOutTrafficErrorsPage: pageNumber + 1,
        isFirstOutTrafficErrorsPage: false
      });
    }
    else if (reportPart === "log" && this.state.isFirstLogPage) {
      this.setState({
        monitoringFirstLogPage: pageNumber + 1,
        isFirstLogPage: false
      });
    }
  }

  // ----------------- Generate Report --------------------------
  createReport = () => {
    let doc = <Document
      title={Strings.REPORT_EXPORT_NAME}>
      {this.createGeneralInfoPage()}
      {this.createDataInfoPage()}
      {this.createSummaryPage()}
      {this.createOverviewPage()}
      {this.createMonitoringLiveListPages()}
      {this.createMonitoringInventoryPages()}
      {this.createMonitoringTopologyPages()}
      {this.createMonitoringInputTrafficErrorsPages()}
      {this.createMonitoringOutputTrafficErrorsPages()}
      {this.createMonitoringLogPages()}
      {this.createDisclaimerPage()}
    </Document>;

    return doc;
  }

  // ----------------- General Information ---------------------
  createGeneralInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.GENERAL_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.CLIENT_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.PROJECT_NAME} {this.props.userInput.clientProjectName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME} {this.props.userInput.clientNetworkName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.LOCATION} {this.props.userInput.clientLocation}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_NAME} {this.props.userInput.clientCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.ACCOUNTABLE_NAME} {this.props.userInput.clientAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_ADDRESS} {this.props.userInput.clientAddress}</Text>
            <Text style={reusableStyles.normalText}>{Strings.COMPANY_CITY} {this.props.userInput.clientCity}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.COMPANY_TEL} {this.props.userInput.clientTel}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getClientImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.EXECUTING_COMPANY_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_COMPANY_NAME} {this.props.userInput.executingCompanyName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_ACCOUNTABLE_NAME} {this.props.userInput.executingAccountableName}</Text>
            <Text style={reusableStyles.normalText}>{Strings.EXECUTING_TEL} {this.props.userInput.executingTel}</Text>
            <Text style={reusableStyles.lastInfoText}>{Strings.EXECUTING_EMAIL} {this.props.userInput.executingEmail}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getExecutorImage()}
          </View>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.ANNOTATIONS}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.notesSection}>
          <Text style={reusableStyles.normalText}>{this.props.userInput.notes}</Text>
        </View>

        <Text style={reusableStyles.subHeaderText}>{Strings.CONCLUSION}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <View style={generalInfoStyles.conclusionSection}>

          <View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM_STRING}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.CONFORM_W_RESTRICTION)}
              <Text style={reusableStyles.normalText}>{Strings.CONFORM_W_RESTRICTION_STRING}</Text>
            </View>

            <View style={generalInfoStyles.rectangleSection}>
              {this.getRectImage(this.props.userInput.conformity === Constants.NON_CONFORM)}
              <Text style={reusableStyles.normalText}>{Strings.NON_CONFORM_STRING}</Text>
            </View>

          </View>

          <View style={generalInfoStyles.signatureLine} />

        </View>

        {this.getPageFooter()}

      </Page >
    );
  }

  getClientImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a client image
    if (this.props.userInput.clientImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.clientImg} />
      );
    }
  }

  getExecutorImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a executor image
    if (this.props.userInput.executorImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.executorImg} />
      );
    }
  }

  // ----------------- Data Information ------------------------
  createDataInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.DATA_REPORT}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.MONITORING_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.NETWORK_TAG_DP}{this.props.tag} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_VERSION_DP}{Constants.TS_MONITOR_VERSION} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MONITOR_TIME_ON_DP}{this.props.uptime} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MEASUREMENT_INTERVAL_DP}{this.props.measurementUptime} </Text>
        <Text style={reusableStyles.normalText}>{Strings.REPORT_GENERATION}{this.getDateTimeNow()} </Text>

        <Text style={reusableStyles.secondSubHeaderText}>{Strings.ETHERNET_INFO}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.configData.addr} </Text>
        <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.configData.netmask} </Text>
        <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.configData.gateway} </Text>

        {this.getWlanOrOfficeInfo()}

        {this.getPageFooter()}

      </Page >
    );
  }

  getConfigModeText = (eth1Mode) => {
    if (eth1Mode === Constants.FIXED_IP_MODE) {
      return Strings.FIXED_IP;
    }
    else if (eth1Mode === Constants.DHCP_MODE) {
      return "DHCP";
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  getWlanOrOfficeInfo = () => {
    const doubleEthPorts = JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY));

    if (doubleEthPorts) {
      return (
        <>
          <Text style={reusableStyles.secondSubHeaderText}>{Strings.ETHERNET_OFFICE_INFO}</Text>

          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.officeEthConfigData.eth1Addr}</Text>
          <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.officeEthConfigData.eth1Netmask}</Text>
          <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.officeEthConfigData.eth1Gateway}</Text>
          <Text style={reusableStyles.normalText}>{Strings.DNS_DP}{this.props.officeEthConfigData.eth1DNS}</Text>
          <Text style={reusableStyles.normalText}>{Strings.MODO_DP}{this.getConfigModeText(this.props.officeEthConfigData.eth1Mode)}</Text>
        </>
      );
    }
    else {
      return (
        <>
          <Text style={reusableStyles.secondSubHeaderText}>{Strings.WLAN_INFO}</Text>

          <View style={reusableStyles.subHeaderLine} />

          <Text style={reusableStyles.normalText}>{Strings.NETWORK_NAME_DP}{this.props.wifiConfigData.wifiName}</Text>
          <Text style={reusableStyles.normalText}>{Strings.IP_DP}{this.props.wifiConfigData.wifiAddr}</Text>
          <Text style={reusableStyles.normalText}>{Strings.MASK_DP}{this.props.wifiConfigData.wifiNetmask}</Text>
          <Text style={reusableStyles.normalText}>{Strings.GATEWAY_DP}{this.props.wifiConfigData.wifiGateway}</Text>
        </>
      );
    }

  }

  // ---------------------- Summary ----------------------------
  createSummaryPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={false}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={reusableStyles.pageTitle}>{Strings.SUMMARY}</Text>

        <Text style={reusableStyles.summaryText} fixed>
          1. {Strings.OVERVIEW} {Strings.OVERVIEW_DOTS} {this.state.monitoringFirstOverviewPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          2. {Strings.LIVE_LIST} {Strings.LIVE_LIST_DOTS} {this.state.monitoringFirstLiveListPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          3. {Strings.INVENTORY} {Strings.INVENTORY_DOTS} {this.state.monitoringFirstInventoryPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          4. {Strings.TOPOLOGY} {Strings.TOPOLOGY_DOTS} {this.state.monitoringFirstTopologyPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          5. {Strings.IN_TRAFFIC_ERRORS} {Strings.IN_TRAFFIC_ERRORS_DOTS} {this.state.monitoringFirstInTrafficErrorsPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          6. {Strings.OUT_TRAFFIC_ERRORS} {Strings.OUT_TRAFFIC_ERRORS_DOTS} {this.state.monitoringFirstOutTrafficErrorsPage}
        </Text>

        <Text style={reusableStyles.summaryText} fixed>
          7. {Strings.LOG} {Strings.MON_LOG_DOTS} {this.state.monitoringFirstLogPage}
        </Text>

        <Text style={reusableStyles.summaryText} render={({ totalPages }) => (
          `8. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_DOTS} ${totalPages}`
        )} fixed />

        {this.getPageFooter()}

      </Page>
    );
  }

  // ----------------- Overview -----------------
  createOverviewPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={monitoringLiveListStyles.pageTitle} fixed>{Strings.M_MONITORING_OVERVIEW_PAGE_TITLE}</Text>

        <Text style={reusableStyles.subHeaderText}>{Strings.TS_MONITOR_VER_DP}{Constants.TS_MONITOR_VERSION}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.secondSubHeaderText}>{Strings.DEVICE_DATA}</Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text style={reusableStyles.normalText}>{Strings.CONTROLLERS_DP}{this.props.deviceStatistics.ioControllers}</Text>
        <Text style={reusableStyles.normalText}>{Strings.DEVICES_DP}{this.props.deviceStatistics.ioDevices}</Text>
        <Text style={reusableStyles.normalText}>{Strings.SUPERVISORS_DP}{this.props.deviceStatistics.supervisors}</Text>
        <Text style={reusableStyles.normalText}>{Strings.OTHER_DEVICES_DP}{this.props.deviceStatistics.notProfinet}</Text>
        <Text style={reusableStyles.normalText}>{Strings.NETWORK_AVAILABILITY_DP}{this.props.networkAvailability}</Text>

        {this.getPageFooter("overview")}

      </Page >
    );
  }

  // ----------------- Live List -----------------
  createMonitoringLiveListPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={monitoringLiveListStyles.pageTitle} fixed>{Strings.M_MONITORING_LIVE_LIST_PAGE_TITLE}</Text>

        <View style={monitoringLiveListStyles.table}>
          {this.createMonitoringLiveListTableHeader()}
          {this.createMonitoringLiveListTable()}
        </View>

        {this.getPageFooter("livelist")}

      </Page>
    );
  }

  createMonitoringLiveListTableHeader = () => {
    return (
      <View style={monitoringLiveListStyles.tableRow} fixed>

        <View style={monitoringLiveListStyles.nameTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={monitoringLiveListStyles.modelTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.MODEL}</Text>
        </View>

        <View style={monitoringLiveListStyles.ipMacTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.IP} / {Strings.MAC}</Text>
        </View>

        <View style={monitoringLiveListStyles.alarmFaultTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.ALARMS}</Text>
        </View>

        <View style={monitoringLiveListStyles.alarmFaultTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.FAULTS}</Text>
        </View>

        <View style={monitoringLiveListStyles.tableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.PING}{"\n"}{Strings.ACTUAL_MEDIUM}</Text>
        </View>

        <View style={monitoringLiveListStyles.tableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>
            {Strings.LOST_PACKET_PERC_1}
            {"\n"}
            {Strings.LOST_PACKET_PERC_2}
          </Text>
        </View>

        <View style={monitoringLiveListStyles.tableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.AVAILABILITY}</Text>
        </View>

        <View style={monitoringLiveListStyles.statusTableColHeader}>
          <Text style={monitoringLiveListStyles.tableCellHeader}>{Strings.STATUS}</Text>
        </View>

      </View>
    );
  }

  createMonitoringLiveListTable = () => {
    return (
      this.props.livelist.map(device => (
        <View style={monitoringLiveListStyles.tableRow} key={device.mac} wrap={false}>

          <View style={monitoringLiveListStyles.nameTableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>
              {UtilsInstance.addWhitespaceToLongStrings(device.name, false)}
            </Text>
          </View>

          <View style={monitoringLiveListStyles.modelTableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>
              {UtilsInstance.addWhitespaceToLongStrings(device.model, false)}
            </Text>
          </View>

          <View style={monitoringLiveListStyles.ipMacTableCol}>
            <Text style={monitoringLiveListStyles.ipTableCellText}>{device.ip}</Text>
            <Text style={monitoringLiveListStyles.macTableCellText}>{UtilsInstance.treatUppercase(device.mac)}</Text>
          </View>

          <View style={monitoringLiveListStyles.alarmFaultTableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{device.nAlarm}</Text>
          </View>

          <View style={monitoringLiveListStyles.alarmFaultTableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{device.nFault}</Text>
          </View>

          <View style={monitoringLiveListStyles.tableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{device.pingAvg} / {device.pingCurrent}</Text>
          </View>

          <View style={monitoringLiveListStyles.tableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{device.lostPings} / {device.lostPingsPercentage}%</Text>
          </View>

          <View style={monitoringLiveListStyles.tableCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{this.getFormatedAvailability(device.availability)}</Text>
          </View>

          {this.createMonitoringStatusCell(device)}

        </View>
      ))
    );
  }

  createMonitoringStatusCell = (device) => {
    if (device.status === Constants.DUPLICATE_IP) {
      return (
        <View style={monitoringLiveListStyles.duplicatedTableStatusCol}>
          <Text style={monitoringLiveListStyles.blacklistTableCell}>{Strings.DUPLICATE_IP_STRING}</Text>
        </View>
      );
    }
    else if (device.isInBlacklist && device.isIgnoringMonitoring) {
      return (
        <View style={monitoringLiveListStyles.blacklistTableStatusCol}>
          <Text style={monitoringLiveListStyles.blacklistTableCell}>
            {Strings.MONITORING_BLACKLIST_STRING_1}{"\n"}{Strings.MONITORING_BLACKLIST_STRING_2}
          </Text>
        </View>
      );
    }
    else if (device.isInBlacklist && !device.isIgnoringMonitoring) {
      if (device.status === Constants.OK) {
        return (
          <View style={monitoringLiveListStyles.okTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.BLACKLIST_OK_STRING}</Text>
          </View>
        );
      }
      else if (device.status === Constants.DIAGNOSTIC) {
        return (
          <View style={monitoringLiveListStyles.diagnosticTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.BLACKLIST_ALARM_STRING}</Text>
          </View>
        );
      }
      else if (device.status === Constants.OFFLINE) {
        return (
          <View style={monitoringLiveListStyles.offlineTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.BLACKLIST_OFFLINE_STRING}</Text>
          </View>
        );
      }
      else if (device.status === Constants.ONLINE) {
        return (
          <View style={monitoringLiveListStyles.onlineTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.BLACKLIST_ONLINE_STRING}</Text>
          </View>
        );
      }
      else if (device.status === Constants.FAULT) {
        return (
          <View style={monitoringLiveListStyles.faultTableStatusCol}>
            <Text style={monitoringLiveListStyles.blacklistTableCell}>{Strings.BLACKLIST_FAULT_STRING}</Text>
          </View>
        );
      }
      // else if (device.status === Constants.DUPLICATE_IP) {
      //   return (
      //     <View style={monitoringLiveListStyles.duplicatedTableStatusCol}>
      //       <Text style={monitoringLiveListStyles.blacklistTableCell}>{Strings.BLACKLIST_DUPLICATE_IP_STRING}</Text>
      //     </View>
      //   );
      // }
      else if (device.status === Constants.CONFIG_ERROR) {
        return (
          <View style={monitoringLiveListStyles.configErrorTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.BLACKLIST_CONFIG_ERROR_STRING}</Text>
          </View>
        );
      }
    }
    else {
      if (device.status === Constants.OK) {
        return (
          <View style={monitoringLiveListStyles.okTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.OK_STRING}</Text>
          </View>
        );
      }
      else if (device.status === Constants.DIAGNOSTIC) {
        return (
          <View style={monitoringLiveListStyles.diagnosticTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.ALARM}</Text>
          </View>
        );
      }
      else if (device.status === Constants.OFFLINE) {
        return (
          <View style={monitoringLiveListStyles.offlineTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.OFFLINE_STRING}</Text>
          </View>
        );
      }
      else if (device.status === Constants.ONLINE) {
        return (
          <View style={monitoringLiveListStyles.onlineTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.ONLINE_STRING}</Text>
          </View>
        );
      }
      else if (device.status === Constants.FAULT) {
        return (
          <View style={monitoringLiveListStyles.faultTableStatusCol}>
            <Text style={monitoringLiveListStyles.blacklistTableCell}>{Strings.FAULT_STRING}</Text>
          </View>
        );
      }
      // else if (device.status === Constants.DUPLICATE_IP) {
      //   return (
      //     <View style={monitoringLiveListStyles.duplicatedTableStatusCol}>
      //       <Text style={monitoringLiveListStyles.blacklistTableCell}>{Strings.DUPLICATE_IP_STRING}</Text>
      //     </View>
      //   );
      // }
      else if (device.status === Constants.CONFIG_ERROR) {
        return (
          <View style={monitoringLiveListStyles.configErrorTableStatusCol}>
            <Text style={monitoringLiveListStyles.tableCell}>{Strings.CONFIG_ERROR_STRING}</Text>
          </View>
        );
      }
    }
  }

  getFormatedAvailability = (availability) => {
    if (availability !== null && availability !== undefined && typeof (availability) === "number") {
      return availability.toFixed(2).replace(".", ",").concat("%");
    }
    else {
      return "";
    }
  }

  // ----------------- Inventory -----------------
  createMonitoringInventoryPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={monitoringInventoryStyles.pageTitle} fixed>{Strings.M_MONITORING_INVENTORY_PAGE_TITLE}</Text>

        <View style={monitoringInventoryStyles.table}>
          {this.createMonitoringInventoryTableHeader()}
          {this.createMonitoringInventoryTable()}
        </View>

        {this.getPageFooter("inventory")}

      </Page>
    );
  }

  createMonitoringInventoryTableHeader = () => {
    return (
      <View style={monitoringInventoryStyles.tableRow} fixed>

        <View style={monitoringInventoryStyles.nameTableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.MAC}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.FUNCTION}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.MODEL}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.MANUFACTURER}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.ORDER_NUMBER}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.HARDWARE_VERSION_N}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{Strings.FIRMWARE_VERSION_N}</Text>
        </View>

        <View style={monitoringInventoryStyles.tableColHeader}>
          <Text style={monitoringInventoryStyles.tableCellHeader}>{`${Strings.IO_CONTROLLER}\n${Strings.ASSOCIATED}`}</Text>
        </View>
      </View>
    );
  }

  createMonitoringInventoryTable = () => {
    return (
      this.props.inventory.map(device => (
        <View style={monitoringInventoryStyles.tableRow} key={device.mac} wrap={false}>

          <View style={monitoringInventoryStyles.nameTableCol}>
            <Text style={monitoringInventoryStyles.tableCell}>
              {UtilsInstance.addWhitespaceToLongStrings(device.name, false)}
            </Text>
          </View>

          <View style={monitoringInventoryStyles.tableCol}>
            <Text style={monitoringInventoryStyles.macTableCellText}>{UtilsInstance.treatUppercase(device.mac)}</Text>
          </View>

          <View style={monitoringInventoryStyles.tableCol}>
            <Text style={monitoringInventoryStyles.ipTableCellText}>{device.ip}</Text>
          </View>

          <View style={monitoringInventoryStyles.tableCol}>
            <Text style={monitoringInventoryStyles.ipTableCellText}>{device.role}</Text>
          </View>

          <View style={monitoringInventoryStyles.tableCol}>
            <Text style={monitoringInventoryStyles.tableCell}>
              {UtilsInstance.addWhitespaceToLongStrings(device.model, false)}
            </Text>
          </View>

          <View style={monitoringInventoryStyles.tableCol}>
            <Text style={monitoringInventoryStyles.tableCell}>{device.manufacturer}</Text>
          </View>

          <View style={monitoringInventoryStyles.tableCol}>
            <Text style={monitoringInventoryStyles.tableCell}>
              {UtilsInstance.addWhitespaceToLongStrings(device.orderNumber, false)}
            </Text>
          </View>

          <View style={monitoringInventoryStyles.tableCol}>
            <Text style={monitoringInventoryStyles.tableCell}>{device.hardwareVersion}</Text>
          </View>

          <View style={monitoringInventoryStyles.tableCol}>
            <Text style={monitoringInventoryStyles.tableCell}>{device.firmwareVersion}</Text>
          </View>

          {this.getIoControllerCell(device.ioControllerList)}

        </View>
      ))
    );
  }

  getIoControllerCell = (ioControllerList) => {
    if (ioControllerList.length > 0) {
      return (
        <View style={monitoringInventoryStyles.tableCol}>
          <Text style={monitoringInventoryStyles.tableCell}>
            {ioControllerList.map(ioController => {
              if (ioController != null) {
                return `${UtilsInstance.addWhitespaceToLongStrings(ioController)}\n`;
              }
              else {
                return Strings.NO_IO_CONTROLLER;
              }
            })}
          </Text>
        </View>
      );
    }
    else {
      return (
        <View style={monitoringInventoryStyles.tableCol}>
          <Text style={monitoringInventoryStyles.tableCell}>{Strings.NO_IO_CONTROLLER}</Text>
        </View>
      );
    }
  }

  // ----------------- Topology -----------------
  createMonitoringTopologyPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={monitoringTopologyStyles.pageTitle} fixed>{Strings.M_MONITORING_TOPOLOGY_PAGE_TITLE}</Text>

        <View style={monitoringTopologyStyles.table}>
          {this.createMonitoringTopologyTableHeader()}
          {this.createMonitoringTopologyTable()}
        </View>

        {this.getPageFooter("topology")}

      </Page>
    );
  }

  createMonitoringTopologyTableHeader = () => {
    return (
      <View style={monitoringTopologyStyles.tableRow} fixed>

        <View style={monitoringTopologyStyles.snmpTableColHeader}>
          <Text style={monitoringTopologyStyles.tableCellHeader}>{Strings.SNMP}</Text>
        </View>

        <View style={monitoringTopologyStyles.nameTableColHeader}>
          <Text style={monitoringTopologyStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={monitoringTopologyStyles.modelTableColHeader}>
          <Text style={monitoringTopologyStyles.tableCellHeader}>{Strings.MODEL}</Text>
        </View>

        <View style={monitoringTopologyStyles.ipTableColHeader}>
          <Text style={monitoringTopologyStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={monitoringTopologyStyles.portTableColHeader}>
          <Text style={monitoringTopologyStyles.tableCellHeader}>{Strings.PORT}</Text>
        </View>

        <View style={monitoringTopologyStyles.nameTableColHeader}>
          <Text style={monitoringTopologyStyles.tableCellHeader}>{Strings.NEIGHBOUR_NAME}</Text>
        </View>

        <View style={monitoringTopologyStyles.portTableColHeader}>
          <Text style={monitoringTopologyStyles.tableCellHeader}>{Strings.NEIGHBOUR_PORT_1} {"\n"}{Strings.NEIGHBOUR_PORT_2}</Text>
        </View>

        <View style={monitoringTopologyStyles.ipTableColHeader}>
          <Text style={monitoringTopologyStyles.tableCellHeader}>{Strings.NEIGHBOUR_IP}</Text>
        </View>

      </View>
    );
  }

  createMonitoringTopologyTable = () => {
    return (
      this.props.topology.map(device => (
        <View wrap={true} key={device.ip}>
          <View wrap={false} style={monitoringTopologyStyles.deviceTableRow}>

            <View style={monitoringTopologyStyles.snmpTableCol}>
              <Text style={monitoringTopologyStyles.tableCell}>{device.snmp}</Text>
            </View>

            <View style={monitoringTopologyStyles.nameTableCol}>
              <Text style={monitoringTopologyStyles.tableCell}>
                {UtilsInstance.getDeviceName(device.name, Strings, UtilsInstance)}
              </Text>
            </View>

            <View style={monitoringTopologyStyles.modelTableCol}>
              <Text style={monitoringTopologyStyles.tableCell}>
                {UtilsInstance.addWhitespaceToLongStrings(device.model, true)}
              </Text>
            </View>

            <View style={monitoringTopologyStyles.ipTableCol}>
              <Text style={monitoringTopologyStyles.tableCell}>{device.ip}</Text>
            </View>

            <View style={monitoringTopologyStyles.portTableCol}>
              <Text style={monitoringTopologyStyles.tableCell}></Text>
            </View>

            <View style={monitoringTopologyStyles.nameTableCol}>
              <Text style={monitoringTopologyStyles.tableCell}></Text>
            </View>

            <View style={monitoringTopologyStyles.portTableCol}>
              <Text style={monitoringTopologyStyles.tableCell}></Text>
            </View>

            <View style={monitoringTopologyStyles.ipTableCol}>
              <Text style={monitoringTopologyStyles.tableCell}></Text>
            </View>

          </View>

          {
            device.connections.map(connection => {
              return (
                <View wrap={false} style={monitoringTopologyStyles.tableRow} key={connection.selfPort}>

                  <View style={monitoringTopologyStyles.snmpTableCol}>
                    <Text style={monitoringTopologyStyles.tableCell}></Text>
                  </View>

                  <View style={monitoringTopologyStyles.nameTableCol}>
                    <Text style={monitoringTopologyStyles.tableCell}></Text>
                  </View>

                  <View style={monitoringTopologyStyles.modelTableCol}>
                    <Text style={monitoringTopologyStyles.tableCell}></Text>
                  </View>

                  <View style={monitoringTopologyStyles.ipTableCol}>
                    <Text style={monitoringTopologyStyles.tableCell}></Text>
                  </View>

                  <View style={monitoringTopologyStyles.portTableCol}>
                    <Text style={monitoringTopologyStyles.tableCell}>{connection.selfPort}</Text>
                  </View>

                  <View style={monitoringTopologyStyles.nameTableCol}>
                    <Text style={monitoringTopologyStyles.tableCell}>
                      {UtilsInstance.getDeviceName(connection.neighborName, Strings, UtilsInstance)}
                    </Text>
                  </View>

                  <View style={monitoringTopologyStyles.portTableCol}>
                    <Text style={monitoringTopologyStyles.tableCell}>{connection.neighborPort}</Text>
                  </View>

                  <View style={monitoringTopologyStyles.ipTableCol}>
                    <Text style={monitoringTopologyStyles.tableCell}>
                      {UtilsInstance.getDeviceIP(connection.neighborIP, Strings)}
                    </Text>
                  </View>

                </View>
              );
            })
          }

        </View>
      ))
    );
  }

  // ----------------- Input Traffic Errors -----------------
  createMonitoringInputTrafficErrorsPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={monitoringInputTrafficErrorsStyles.pageTitle} fixed>{Strings.M_MONITORING_IN_TRAFFIC_ERRORS_PAGE_TITLE}</Text>

        {this.getMonitoringInputTrafficErrorsInfo()}
        {this.getPageFooter("inerror")}

      </Page>
    );
  }

  getMonitoringInputTrafficErrorsInfo() {
    if (this.props.devicesWithInputTrafficErrors.length > 0) {
      return (
        <View style={monitoringInputTrafficErrorsStyles.table}>
          {this.createMonitoringInputTrafficErrorsTableHeader()}
          {this.createMonitoringInputTrafficErrorsTable()}
        </View>
      );
    }
    else {
      return (
        <Text style={monitoringInputTrafficErrorsStyles.noErrors}>{Strings.NO_INPUT_TRAFFIC_ERRORS}</Text>
      );
    }
  }

  createMonitoringInputTrafficErrorsTableHeader = () => {
    return (
      <View style={monitoringInputTrafficErrorsStyles.tableRow} fixed>

        <View style={monitoringInputTrafficErrorsStyles.ipTableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.timeTableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.ON_TIME}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.DUPLEX_MODE}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>
            {Strings.LINE_DELAY_VALUE_1}
          </Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>
            {Strings.INTERFACE_SPEED_1}{"\n"}{Strings.INTERFACE_SPEED_2}
          </Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.INPUT}{"\n"}(Kbps)</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.ERRORS_IN}{"\n"}{Strings.INPUT}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.PORT_STATUS}</Text>
        </View>
      </View>
    );
  }

  createMonitoringInputTrafficErrorsTable = () => {
    return (
      this.props.devicesWithInputTrafficErrors.map(device => (
        <View key={device.ip}>

          <View wrap={false} style={monitoringInputTrafficErrorsStyles.deviceTableRow}>

            <View style={monitoringInputTrafficErrorsStyles.ipTableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{device.ip}</Text>
            </View>

            <View style={monitoringInputTrafficErrorsStyles.tableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                {UtilsInstance.getDeviceName(device.name, Strings, UtilsInstance)}
              </Text>
            </View>

            <View style={monitoringInputTrafficErrorsStyles.timeTableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{this.formatUptimeStringToRelativeTime(device.uptime)}</Text>
            </View>

            <View style={monitoringInputTrafficErrorsStyles.whitespaceTableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}></Text>
            </View>

          </View>

          {
            device.ports.map(port => {
              return (
                <View wrap={false} style={monitoringInputTrafficErrorsStyles.tableRow} key={port.name}>

                  <View style={monitoringInputTrafficErrorsStyles.portNameTableCol}>
                    <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{port.name}</Text>
                  </View>

                  {this.getMAUTypeCell(port.MAUType)}
                  {this.getLineDelayValueCell(port.lineDelayValue)}
                  {this.getSpeedCell(port.speed)}
                  {this.getTrafficSpeedKbpsCell(port.inputKbps)}
                  {this.createErrorsTableCell(port.inputErrors, port.inputErrorsIncrement)}
                  {this.getLinkStateLinkCell(port.linkStateLink)}
                </View>
              );
            })
          }

        </View>
      ))
    );
  }

  getMAUTypeCell = (MAUType) => {
    if (MAUType === null) {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else if (MAUType === "") {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    if (MAUType.toUpperCase() === Constants.UNKNOWN_UPPERCASE) {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{MAUType}</Text>
        </View>
      );
    }
  }

  getLineDelayValueCell = (lineDelayValue) => {
    if (lineDelayValue === null) {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else if (lineDelayValue === "") {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else if (lineDelayValue.toUpperCase() === "UNKNOWN") {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else {
      if (lineDelayValue.toUpperCase().includes("IN NANOSECONDS")) {
        // Como o texto vai estar neste formato: Cable delay in nanoseconds (264)
        // vamos pegar apenas o valor numÃ©rico do delay entre parÃªnteses usando expressÃµes regulares
        const delayValueRegex = /\((\d+)\)/;
        const delayMatch = lineDelayValue.match(delayValueRegex);
        const delayValue = Number(delayMatch[1]);

        if (delayMatch) {
          if (lineDelayValue.toUpperCase().includes("CABLE")) {
            if (delayValue > 528) {
              return (
                <View style={monitoringInputTrafficErrorsStyles.errorTableCol}>
                  <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                    {Strings.CABLE_DELAY}: {delayValue} ns
                  </Text>
                </View>
              );
            }
            else {
              return (
                <View style={monitoringInputTrafficErrorsStyles.tableCol}>
                  <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                    {Strings.CABLE_DELAY}: {delayValue} ns
                  </Text>
                </View>
              );
            }
          }
          else {
            if (delayValue > 528) {
              return (
                <View style={monitoringInputTrafficErrorsStyles.errorTableCol}>
                  <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                    {Strings.LINE_DELAY}: {delayValue} ns
                  </Text>
                </View>
              );
            }
            else {
              return (
                <View style={monitoringInputTrafficErrorsStyles.tableCol}>
                  <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                    {Strings.LINE_DELAY}: {delayValue} ns
                  </Text>
                </View>
              );
            }
          }
        }
        else {
          return (
            <View style={monitoringInputTrafficErrorsStyles.tableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                {lineDelayValue}
              </Text>
            </View>
          );
        }
      }
      else {
        // Esse split serve para pegar o valor do delay
        // Ex: Cable delay: 234 -> ['Cable delay ',' 234']
        // Ex: Line delay: 234 -> ['Line delay ',' 234']
        let splittedLineDelay = lineDelayValue.split(":");
        // Se houver ao menos dois elementos no array apÃ³s o split, Ã© por que deu certo
        if (splittedLineDelay.length > 1) {
          // Pegue o valor do delay (que estÃ¡ no Ã­ndice 1), retire os espaÃ§os em branco e transforme em nÃºmero
          const delayText = lineDelayValue.split(":")[0].trim();
          const delayValue = Number(lineDelayValue.split(":")[1].trim(" ", ""));
          // Se o delay for maior que 528, pinte a cÃ©lula de laranja
          if (delayValue > 528) {
            return (
              <View style={monitoringInputTrafficErrorsStyles.errorTableCol}>
                <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                  {delayText}: {delayValue} ns
                </Text>
              </View>
            );
          }
          else {
            return (
              <View style={monitoringInputTrafficErrorsStyles.tableCol}>
                <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                  {delayText}: {delayValue} ns
                </Text>
              </View>
            );
          }
        }
        // Se nÃ£o houver dois elementos apÃ³s o split, o valor de delay veio em um formato nÃ£o padrÃ£o
        // EntÃ£o apenas mostre na tela o texto, sem nenhum prÃ©-processamento
        else {
          return (
            <View style={monitoringInputTrafficErrorsStyles.tableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                {lineDelayValue}
              </Text>
            </View>
          );
        }
      }
    }
  }

  getSpeedCell = (interface_speed) => {
    if (interface_speed !== "") {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{interface_speed} Mbps</Text>
        </View>
      );
    }
    else {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
  }

  createErrorsTableCell = (errors, increment) => {
    if (errors === "") {
      return (
        <View style={monitoringInputTrafficErrorsStyles.errorTableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else {
      if (increment > 0) {
        return (
          <View style={monitoringInputTrafficErrorsStyles.errorTableCol}>
            <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{errors}</Text>
          </View>
        );
      }
      else {
        return (
          <View style={monitoringInputTrafficErrorsStyles.tableCol}>
            <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{errors}</Text>
          </View>
        );
      }
    }
  }

  getLinkStateLinkCell = (linkStateLink) => {
    if (linkStateLink === "up") {
      return (
        <View style={monitoringInputTrafficErrorsStyles.activeTableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.ACTIVE}</Text>
        </View>
      );
    }
    else if (linkStateLink === "down") {
      return (
        <View style={monitoringInputTrafficErrorsStyles.unknownTableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.INACTIVE}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={monitoringInputTrafficErrorsStyles.unknownTableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
  }

  getTrafficSpeedKbpsCell = (kbps) => {
    if (kbps === null) {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else if (kbps === "") {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{Strings.NO_ANSWER}</Text>
        </View>
      );
    }
    else {
      return (
        <View style={monitoringInputTrafficErrorsStyles.tableCol}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{parseFloat(kbps).toFixed(2)}</Text>
        </View>
      );
    }
  }

  // ----------------- Output Traffic Errors -----------------
  createMonitoringOutputTrafficErrorsPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}
        <Text style={monitoringInputTrafficErrorsStyles.pageTitle} fixed>{Strings.M_MONITORING_OUT_TRAFFIC_ERRORS_PAGE_TITLE}</Text>

        {this.getMonitoringOutputTrafficErrorsInfo()}
        {this.getPageFooter("outerror")}

      </Page>
    );
  }

  getMonitoringOutputTrafficErrorsInfo() {
    if (this.props.devicesWithOutputTrafficErrors.length > 0) {
      return (
        <View style={monitoringInputTrafficErrorsStyles.table}>
          {this.createMonitoringOutputTrafficErrorsTableHeader()}
          {this.createMonitoringOutputTrafficErrorsTable()}
        </View>
      );
    }
    else {
      return (
        <Text style={monitoringInputTrafficErrorsStyles.noErrors}>{Strings.NO_OUTPUT_TRAFFIC_ERRORS}</Text>
      );
    }
  }

  createMonitoringOutputTrafficErrorsTableHeader = () => {
    return (
      <View style={monitoringInputTrafficErrorsStyles.tableRow} fixed>

        <View style={monitoringInputTrafficErrorsStyles.ipTableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.timeTableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.ON_TIME}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.DUPLEX_MODE}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>
            {Strings.LINE_DELAY_VALUE_1}{"\n"}{Strings.LINE_DELAY_VALUE_2}
          </Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>
            {Strings.INTERFACE_SPEED_1}{"\n"}{Strings.INTERFACE_SPEED_2}
          </Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.OUTPUT}{"\n"}(Kbps)</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.ERRORS_IN}{"\n"}{Strings.OUTPUT}</Text>
        </View>

        <View style={monitoringInputTrafficErrorsStyles.tableColHeader}>
          <Text style={monitoringInputTrafficErrorsStyles.tableCellHeader}>{Strings.PORT_STATUS}</Text>
        </View>
      </View>
    );
  }

  createMonitoringOutputTrafficErrorsTable = () => {
    return (
      this.props.devicesWithOutputTrafficErrors.map(device => (
        <View key={device.ip}>

          <View wrap={false} style={monitoringInputTrafficErrorsStyles.deviceTableRow}>

            <View style={monitoringInputTrafficErrorsStyles.ipTableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{device.ip}</Text>
            </View>

            <View style={monitoringInputTrafficErrorsStyles.tableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}>
                {UtilsInstance.getDeviceName(device.name, Strings, UtilsInstance)}
              </Text>
            </View>

            <View style={monitoringInputTrafficErrorsStyles.timeTableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{
                this.formatUptimeStringToRelativeTime(device.uptime)}
              </Text>
            </View>

            <View style={monitoringInputTrafficErrorsStyles.whitespaceTableCol}>
              <Text style={monitoringInputTrafficErrorsStyles.tableCell}></Text>
            </View>

          </View>

          {
            device.ports.map(port => {
              return (
                <View wrap={false} style={monitoringInputTrafficErrorsStyles.tableRow} key={port.name}>

                  <View style={monitoringInputTrafficErrorsStyles.portNameTableCol}>
                    <Text style={monitoringInputTrafficErrorsStyles.tableCell}>{port.name}</Text>
                  </View>

                  {this.getMAUTypeCell(port.MAUType)}
                  {this.getLineDelayValueCell(port.lineDelayValue)}
                  {this.getSpeedCell(port.speed)}
                  {this.getTrafficSpeedKbpsCell(port.exitKbps)}
                  {this.createErrorsTableCell(port.exitErrors, port.exitErrorsIncrement)}
                  {this.getLinkStateLinkCell(port.linkStateLink)}
                </View>
              );
            })
          }

        </View>
      ))
    );
  }

  // ----------------- Log -----------------
  createMonitoringLogPages = () => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <Text style={monitoringLogStyles.pageTitle} fixed>{Strings.M_MONITORING_LOG_PAGE_TITLE}</Text>
        <Text style={monitoringLogStyles.pageLastEventsText} fixed>{Strings.LAST_200_EVENTS}</Text>

        <View style={monitoringLogStyles.table}>
          {this.createMonitoringLogTableHeader()}
          {this.createMonitoringLogTable()}
        </View>

        {this.getPageFooter("log")}

      </Page>
    );
  }

  createMonitoringLogTableHeader = () => {
    return (
      <View style={monitoringLogStyles.tableRow} fixed>

        <View style={monitoringLogStyles.horaryTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={monitoringLogStyles.nameModelTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.NAME}</Text>
        </View>

        <View style={monitoringLogStyles.nameModelTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.MODEL}</Text>
        </View>

        <View style={monitoringLogStyles.ipTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.IP}</Text>
        </View>

        <View style={monitoringLogStyles.descriptionTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.DESCRIPTION}</Text>
        </View>

      </View>
    );
  }

  createMonitoringLogTable = () => {
    return (
      this.props.log.map(logEntry => (
        <View wrap={true} key={logEntry.event}>
          <View wrap={false} style={monitoringLogStyles.tableRow} key={logEntry.event}>

            <View style={monitoringLogStyles.horaryTableCol}>
              <Text style={monitoringLogStyles.tableCell}>{this.getMonitoringLogTime(logEntry)}</Text>
            </View>

            <View style={monitoringLogStyles.nameModelTableCol}>
              <Text style={monitoringLogStyles.tableCell}>
                {UtilsInstance.getDeviceName(logEntry.name, Strings, UtilsInstance)}
              </Text>
            </View>

            <View style={monitoringLogStyles.nameModelTableCol}>
              <Text style={monitoringLogStyles.tableCell}>
                {UtilsInstance.addWhitespaceToLongStrings(logEntry.model, false)}
              </Text>
            </View>

            <View style={monitoringLogStyles.ipTableCol}>
              <Text style={monitoringLogStyles.tableCell}>{logEntry.ip}</Text>
            </View>

            <View style={monitoringLogStyles.descriptionTableCol}>
              {this.getDescriptionTableCell(logEntry)}
            </View>
          </View>
          {this.getLongDescriptionTableRow(logEntry)}
        </View>
      ))
    );
  }

  formatTime = (eventTimeInSeconds) => {
    if (eventTimeInSeconds !== undefined && eventTimeInSeconds !== null) {
      const eventTimeInMillis = eventTimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow);
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getMonitoringLogTime = (logEntry) => {
    if (logEntry.time === null) {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
    else {
      let dateToShow = "";

      if (logEntry.ntp !== null && logEntry.ntp === true) {
        dateToShow = new Date(Date.parse(logEntry.time));
      }
      else {
        dateToShow = this.formatTime(logEntry.time);
      }

      let year = dateToShow.getFullYear();
      let month = dateToShow.getMonth() + 1;
      let day = dateToShow.getDate();
      let hour = dateToShow.getHours();
      let minutes = dateToShow.getMinutes();

      if (day < 10) { day = "0" + day; }
      if (month < 10) { month = "0" + month; }
      if (hour < 10) { hour = "0" + hour; }
      if (minutes < 10) { minutes = "0" + minutes; }

      return day + "/" + month + "/" + year + " " + hour + ":" + minutes;
    }
  }

  getLogTag = (logEntry) => {
    if (parseInt(logEntry.address) !== 128) {
      if (logEntry.tag === "") {
        return "-";
      }
      else {
        return logEntry.tag;
      }
    }
    else {
      return Strings.NETWORK_EVENT;
    }
  }

  getDescriptionTableCell = (logEntry) => {
    // If the description is an object (multiple lines) return a table cell with only 'Alarme' written on it
    if (typeof (logEntry.description) === "object") {
      if (logEntry.description.entrada !== undefined) {
        return (<Text style={monitoringLogStyles.tableCell}>{Strings.DEVICE_HAS_JOINED_THE_NETWORK}</Text>);
      }
      else {
        return (<Text style={monitoringLogStyles.tableCell}>{Strings.ALARM}</Text>);
      }
    }
    // If the description is a string and contains '->' it is a status change
    else if (typeof (logEntry.description) === "string" && logEntry.description.includes("->")) {
      return (
        <Text style={monitoringLogStyles.tableCellLeft}>
          <Text style={{ fontFamily: "RobotoMedium" }}>{Strings.STATUS_CHANGE}</Text>
          {logEntry.description}
        </Text>
      );
    }
    // logEntry.description.split("dispositivo de MAC").length -1 === 2
    // Se essa verificaÃ§Ã£o for true, significa que Ã© um evento de IP duplicado
    else if (typeof (logEntry.description) === "string"
      && ((logEntry.description.split("dispositivo de MAC").length - 1 === 2)
        || logEntry.description.split("device of MAC").length - 1 === 2)) {
      return (
        <Text style={monitoringLogStyles.tableCellLeft}>
          <Text style={{ fontFamily: "RobotoMedium" }}>{Strings.DUPLICATE_IP}</Text>
          {logEntry.description}
        </Text>
      );
    }
    // Othwerwise, just return a table cell with the string written on it
    else {
      return (<Text style={monitoringLogStyles.tableCellLeft}>{logEntry.description}</Text>);
    }
  }

  // Returns an array containing the active alarms of a log entry sorted by
  // severity level descending (3:Failure > 2 > 1 > 0:none)
  getDescendingOrderedActiveLogEntryAlarms = (logEntry) => {
    let descendingOrderedLogEntryAlarms = [];

    if (typeof (logEntry.description) === "object") {

      Object.keys(logEntry.description.alarmeAtivo).forEach((key) => {
        descendingOrderedLogEntryAlarms.push(
          {
            "contents": logEntry.description.alarmeAtivo[key],
            "module": key
          }
        );
      });

      for (let i = 0; i < descendingOrderedLogEntryAlarms.length; i++) {
        descendingOrderedLogEntryAlarms[i].contents.sort(UtilsInstance.sortBy("severityNumber", true, parseInt));
      }
    }

    return descendingOrderedLogEntryAlarms;
  }

  // Returns an array containing the non active alarms of a log entry sorted by
  // severity level descending (3:Failure > 2 > 1 > 0:none)
  getDescendingOrderedNotActiveLogEntryAlarms = (logEntry) => {
    let descendingOrderedLogEntryAlarms = [];

    if (typeof (logEntry.description) === "object") {

      Object.keys(logEntry.description.alarmeDesaparecido).forEach((key) => {
        descendingOrderedLogEntryAlarms.push(
          {
            "contents": logEntry.description.alarmeDesaparecido[key],
            "module": key
          }
        );
      });

      for (let i = 0; i < descendingOrderedLogEntryAlarms.length; i++) {
        descendingOrderedLogEntryAlarms[i].contents.sort(UtilsInstance.sortBy("severityNumber", true, parseInt));
      }
    }

    return descendingOrderedLogEntryAlarms;
  }

  // Returns a new row with two columns containing the log description divided between active
  // and not active
  getAlarmDescriptionTableRow = (logEntryDescription, activeLogEntryAlarms, notActiveLogEntryAlarms) => {
    if (typeof (logEntryDescription) === "object") {
      let activeModuleInformation = [];
      let notActiveModuleInformation = [];

      for (let i = 0; i < activeLogEntryAlarms.length; i++) {
        activeModuleInformation.push({
          "moduleName": <Text style={monitoringLogStyles.alarmTitleFontStyle}> {activeLogEntryAlarms[i].module} {Strings.REPORTING}</Text>,
          "activeAlarms": activeLogEntryAlarms[i].contents.map(content => {
            return this.getAlarmColorAndText(content);
          })
        });
      }

      for (let i = 0; i < notActiveLogEntryAlarms.length; i++) {
        notActiveModuleInformation.push({
          "moduleName": <Text style={monitoringLogStyles.alarmTitleFontStyle}> {notActiveLogEntryAlarms[i].module} {Strings.REPORTING}</Text>,
          "notActiveAlarms": notActiveLogEntryAlarms[i].contents.map(content => {
            return this.getAlarmColorAndText(content);
          })
        });
      }

      let activeInformationMap = "";
      let notActiveInformationMap = "";

      if (activeModuleInformation.length === 0) {
        activeInformationMap = <Text style={monitoringLogStyles.alarmTableCell}>{Strings.NO_EVENT}</Text>;
      }
      else {
        activeInformationMap = activeModuleInformation.map(moduleInformation => {
          return this.getActiveAlarmModuleInfo(moduleInformation);
        });
      }

      if (notActiveModuleInformation.length === 0) {
        notActiveInformationMap = <Text style={monitoringLogStyles.alarmTableCell}>{Strings.NO_EVENT}</Text>;
      }
      else {
        notActiveInformationMap = notActiveModuleInformation.map(moduleInformation => {
          return this.getNotActiveAlarmModuleInfo(moduleInformation);
        });
      }

      return (
        <View style={monitoringLogStyles.tableRow}>
          <View style={monitoringLogStyles.leftAlarmDescriptionTableCol}>
            <Text style={monitoringLogStyles.alarmTitleFontStyle}>{Strings.ACTIVE_DP}</Text>
            {activeInformationMap}
          </View>
          <View style={monitoringLogStyles.rightAlarmDescriptionTableCol}>
            <Text style={monitoringLogStyles.alarmTitleFontStyle}>{Strings.NOT_ACTIVE_DP}</Text>
            {notActiveInformationMap}
          </View>
        </View>
      );
    }
  }

  // Returns the alarm text and a circle icon next to it indicating the 
  // severity of the alarm
  getAlarmColorAndText = (alarm) => {
    let alarmText = "";
    let alarmChannel = "";
    let tipText = "";

    if (alarm.channel !== null) {
      alarmChannel = alarm.channel + ": ";
    }

    if (alarm.unknown === true) {
      alarmText = Strings.FROM_GSDML + alarm.array[0] + Strings.MANUFACTURER_TIP;

      for (let i = 1; i < alarm.array.length; i++) {
        let lowercaseFirstLetter = alarm.array[i].toLowerCase() + ", ";
        alarmText = alarmText.concat(lowercaseFirstLetter);
      }
      alarmText = alarmText.slice(0, alarmText.length - 2);
      alarmText = alarmText.concat(").");
    }
    else {
      for (let i = 0; i < alarm.array.length; i++) {
        if (i > 0) {
          alarmText = alarmText.concat(alarm.array[i].toLowerCase(), ", ");
        }
        else {
          alarmText = alarmText.concat(alarm.array[i], ", ");
        }
      }
      alarmText = alarmText.slice(0, alarmText.length - 2);
    }

    if (alarm.tip !== undefined && alarm.tip !== null) {
      tipText = <>. (<Text style={monitoringLogStyles.tipText}>{Strings.TIP}</Text> {alarm.tip}).</>;
    }

    switch (alarm.severity) {
      case Constants.ALARM_FAILURE:
        return (
          <Text style={monitoringLogStyles.alarmTableCell}>
            <Text style={{ color: "red", fontFamily: "RobotoMedium", fontSize: 16 }}>&#8226;</Text>
            {alarmChannel}
            {alarmText}
            {tipText}
          </Text>
        );
      case Constants.ALARM_MAINTENANCE_DEMANDED:
        return (
          <Text style={monitoringLogStyles.alarmTableCell}>
            <Text style={{ color: "orange", fontFamily: "RobotoMedium", fontSize: 16 }}>&#8226;</Text>
            {alarmChannel}
            {alarmText}
            {tipText}
          </Text>
        );
      case Constants.ALARM_MAINTENANCE_REQUIRED:
        return (
          <Text style={monitoringLogStyles.alarmTableCell}>
            <Text style={{ color: "yellow", fontFamily: "RobotoMedium", fontSize: 16 }}>&#8226;</Text>
            {alarmChannel}
            {alarmText}
            {tipText}
          </Text>
        );
      case Constants.ALARM_NONE:
        return (
          <Text style={monitoringLogStyles.alarmTableCell}>
            <Text style={{ color: "grey", fontFamily: "RobotoMedium", fontSize: 16 }}>&#8226;</Text>
            {alarmChannel}
            {alarmText}
            {tipText}
          </Text>
        );
      default:
        return (
          <Text style={monitoringLogStyles.alarmTableCell}>
            <Text style={{ color: "black", fontFamily: "RobotoMedium", fontSize: 16 }}>&#8226;</Text>
            {alarmChannel}
            {alarmText}
            {tipText}
          </Text>
        );
    }
  }

  getActiveAlarmModuleInfo = (module) => {
    return (
      <React.Fragment>
        {module.moduleName}
        {module.activeAlarms}
      </React.Fragment>
    );
  }

  getNotActiveAlarmModuleInfo = (module) => {
    return (
      <React.Fragment>
        {module.moduleName}
        {module.notActiveAlarms}
      </React.Fragment>
    );
  }

  getLongDescriptionTableRow = (logEntry) => {
    if (typeof (logEntry.description) === "object" && logEntry.description.alarmeAtivo !== undefined) {
      return this.getAlarmDescriptionTableRow(
        logEntry.description,
        this.getDescendingOrderedActiveLogEntryAlarms(logEntry),
        this.getDescendingOrderedNotActiveLogEntryAlarms(logEntry));
    }
    else if (typeof (logEntry.description) === "object" && logEntry.description.entrada !== undefined) {
      return this.getNetworkDeviceEntryTableRow(logEntry.description.entrada);
    }
  }

  getNetworkDeviceEntryTableRow = (entry) => {
    let connections = entry.connections.map(connection => {
      return this.getConnectionInfo(connection);
    });

    return (
      <View style={monitoringLogStyles.tableRow}>
        <View style={monitoringLogStyles.deviceEntryDescriptionTableCol}>
          <Text style={monitoringLogStyles.alarmTitleFontStyle}>{Strings.DETAILS}</Text>
          <Text style={monitoringLogStyles.alarmTableCell}>
            {Strings.THE_DEVICE}
            <Text style={monitoringLogStyles.alarmTableCellMedium}> {entry.name} </Text>
            {Strings.OF_IP}
            <Text style={monitoringLogStyles.alarmTableCellMedium}> {entry.ip} </Text>
            {Strings.JOINED_THE_NETWORK}
          </Text>
          {connections}
        </View>
      </View>
    );
  }

  getConnectionInfo(connection) {
    let connectionkey = connection.selfPort
      .concat(connection.neighborPort)
      .concat(connection.neighborName)
      .concat(connection.neighborIP);

    return (
      <Text key={connectionkey} style={monitoringLogStyles.alarmTableCell}>
        {"â€¢ " + Strings.THE_PORT}
        <Text style={monitoringLogStyles.alarmTableCellMedium}> {connection.selfPort} </Text>
        {Strings.IS_CONNECTED_WITH_PORT}
        <Text style={monitoringLogStyles.alarmTableCellMedium}> {connection.neighborPort} </Text>
        {Strings.FROM_DEVICE}
        <Text style={monitoringLogStyles.alarmTableCellMedium}> {connection.neighborName} </Text>
        {Strings.OF_IP}
        <Text style={monitoringLogStyles.alarmTableCellMedium}> {connection.neighborIP}. </Text>
      </Text>
    );
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={reusableStyles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={reusableStyles.pageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "23vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={reusableStyles.subHeaderLine} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  render() {
    return (
      this.createReport()
    );
  }
}

const reusableStyles = StyleSheet.create({
  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  pageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  subHeaderText: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  secondSubHeaderText: {
    marginTop: "3vh",
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  subHeaderLine: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  normalText: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  lastInfoText: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  summaryText: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  }
});

const headerStyles = StyleSheet.create({
  container: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  logo: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  }
});

const footerStyles = StyleSheet.create({
  container: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  line: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  text: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  }
});

const generalInfoStyles = StyleSheet.create({
  notesSection: {
    maxWidth: "510pt",
    width: "90vw",
    height: "14vh"
  },

  conclusionSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "16vh"
  },

  rectangleSection: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },

  rectangle: {
    width: 28,
    height: 28,
    margin: "1vh vw"
  },
  signatureLine: {
    height: "1px",
    width: "40vw",
    backgroundColor: "black",
  }
});

const monitoringLiveListStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  nameTableColHeader: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  modelTableColHeader: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  ipMacTableColHeader: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  alarmFaultTableColHeader: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  statusTableColHeader: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  ipTableCellText: {
    textAlign: "center",
    marginTop: 4,
    marginBottom: 2,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  macTableCellText: {
    textAlign: "center",
    marginBottom: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  blacklistTableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    color: "white",
    fontFamily: "RobotoRegular"
  },

  nameTableCol: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  modelTableCol: {
    width: "13%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  ipMacTableCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  alarmFaultTableCol: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  blacklistTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "black"
  },

  automaticBlacklistTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#8B0000"
  },

  okTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime"
  },

  diagnosticTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow"
  },

  offlineTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#D3D3D3"
  },

  onlineTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ADD8E6"
  },

  faultTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "red"
  },

  duplicatedTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "purple"
  },

  configErrorTableStatusCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FFB6C1"
  },
});

const monitoringInventoryStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  nameTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  ipTableCellText: {
    textAlign: "center",
    marginTop: 4,
    marginBottom: 2,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  macTableCellText: {
    textAlign: "center",
    marginTop: 4,
    marginBottom: 2,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  nameTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
});

const monitoringTopologyStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  deviceTableRow: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5"
  },

  snmpTableColHeader: {
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  nameTableColHeader: {
    width: "19%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  modelTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  portTableColHeader: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  snmpTableCol: {
    width: "7%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  nameTableCol: {
    width: "19%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  modelTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  portTableCol: {
    width: "8%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
});

const monitoringInputTrafficErrorsStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  noErrors: {
    marginTop: "28vh",
    textAlign: "center",
    fontSize: 18,
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  table: {
    display: "table",
    width: "auto",
  },

  tableRow: {
    flexDirection: "row"
  },

  deviceTableRow: {
    flexDirection: "row",
    backgroundColor: "#f5f5f5"
  },

  ipTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  timeTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  ipTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  timeTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  whitespaceTableCol: {
    width: "60%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  errorTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ff6600"
  },

  portNameTableCol: {
    width: "40%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  activeTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime",
  },

  unknownTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#dcdcdc",
  },
});

const monitoringLogStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    fontFamily: "RobotoMedium"
  },

  pageLastEventsText: {
    fontSize: 12,
    marginBottom: "3vh",
    fontFamily: "RobotoRegular"
  },

  table: {
    display: "table",
    width: "auto"
  },

  tableRow: {
    flexDirection: "row"
  },

  horaryTableColHeader: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  nameModelTableColHeader: {
    width: "18%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  ipTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  descriptionTableColHeader: {
    width: "38%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableCol: {
    width: "14%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  nameModelTableCol: {
    width: "18%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  ipTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  descriptionTableCol: {
    width: "38%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  tableCellLeft: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  logDescriptionTableCell: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  logDescriptionTableCellTitle: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoMedium"
  },

  leftAlarmDescriptionTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  rightAlarmDescriptionTableCol: {
    width: "50%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  alarmTableCell: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  alarmTitleFontStyle: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoMedium"
  },

  alarmTableCellMedium: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoMedium"
  },

  deviceEntryDescriptionTableCol: {
    width: "100%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tipText: {
    fontSize: 8,
    fontFamily: "RobotoMedium"
  },
});

export default MonitoringReport;

